import { z } from 'zod'
import { PaginationOptionsSchema } from '../types/api/pagination'
import { FaceMeasurements } from '../types'

export const ErpFrameSchema = z.object({
  wish: z.string(),
  ftype: z.string(),
  vbox: z.number(),
  list_price: z.number(),
  id: z.number(),
  url: z.string().url(),
  default_code: z.string(),
  lot: z.string().nullable(),
  source: z.string(),
  total: z.number(),
  qty: z.number(),
  store_qty: z.number(),
  plc: z.string(),
  attributes: z.record(z.string(), z.string()),
  variant_ids: z.array(z.number()),
})

export const FramesQuerySchema = z
  .object({
    query: z.string(),
    customer_id: z.string().optional(),
    offer: z.string().optional(),
    fcatalog: z.string().optional(),
  })
  .extend(PaginationOptionsSchema.shape)

export type FramesQuery = z.infer<typeof FramesQuerySchema>

export const TraceFrameQuerySchema = z.object({
  id: z.number(),
  code: z.string(),
  inventory_no: z.string(),
})

export type TraceFrameQuery = z.infer<typeof TraceFrameQuerySchema>

export type ErpFrame = z.infer<typeof ErpFrameSchema>

type SHAPE_SETTING = 'y_ext' | 'x_ext'

const SHAPE_CONFIG: Record<string, SHAPE_SETTING[]> = {
  DRILL: ['x_ext', 'y_ext'],
  NYLON: ['y_ext'],
}

export const canChangeShape = (frame: ErpFrame): boolean => {
  if (!frame.ftype) {
    return false
  }
  const allowedShapes = SHAPE_CONFIG[frame.ftype]
  return allowedShapes?.length ? allowedShapes.length > 0 : false
}

type FrameExtend = number | null

export type FrameShape = {
  extend_x: FrameExtend
  extend_y: FrameExtend
}

export type OrderFrame = {
  measurement: FaceMeasurements | null
  shape: FrameShape
} & ErpFrame

export const ShapeUtils = {
  canChangeShape,
  shape: {
    x_ext: (frame: ErpFrame) => SHAPE_CONFIG[frame.ftype]?.includes('x_ext'),
    y_ext: (frame: ErpFrame) => SHAPE_CONFIG[frame.ftype]?.includes('y_ext'),
  },
  getShapes: (frame: ErpFrame) => ({
    y_ext: ShapeUtils.shape.y_ext(frame),
    x_ext: ShapeUtils.shape.x_ext(frame),
  }),
}
